import React from 'react';
import styled from 'styled-components';
import { transparentize } from 'polished';
import { string } from 'prop-types';

const StyledSpan = styled('span')(({ theme }) => ({
  padding: '2px 15px',
  marginBottom: '2px',
  marginRight: '10px',
  verticalAlign: 'middle',
  background: transparentize(0.9, theme.colors.blue),
  display: 'inline-block',
  borderRadius: '20px',
  fontWeight: '800',
  fontSize: '1.3rem',
  color: theme.colors.blue,
  '&:first-child': {
    marginLeft: '10px'
  }
}));

const PartnerCategory = ({ category }) => <StyledSpan>{category}</StyledSpan>;

PartnerCategory.propTypes = { category: string };

export default PartnerCategory;
